import VErrorBackToRefUrl from '@/components/Error/ErrorBackToRefUrl';
import Proxy from '@/proxies/CitaProxy';
import { safeNavigate } from '@/utils/safeUrl';

export default (context, data) => {
  data.retryButtonHook = VErrorBackToRefUrl;

  const parseError = async (cb) => {
    let { refUrl } = context.$store.state.cita;

    if (!refUrl) {
      try {
        refUrl = (await new Proxy().getRefUrl()).refUrl;
      } catch (e) {}
    }

    context.$set(data.retryButtonBindings, 'refUrl', refUrl);

    // SECURITY: safeNavigate only fires for http(s) URLs; otherwise fall through.
    if (context.code === 'CITA_REDIRECT' && refUrl && safeNavigate(refUrl)) {
      return;
    }
    cb();
  };

  return {
    parseError,
  };
};
